import { CanDeactivateFn } from '@angular/router';
import type { ExpedienteDetalleComponent } from './expediente-detalle.component';

export const expedienteDetalleCanDeactivate: CanDeactivateFn<ExpedienteDetalleComponent> = (
  component,
  _currentRoute,
  _currentState,
  nextState,
) => {
  return component.confirmarSalidaSiDatosPendientes(nextState);
};
